export default {
      id: "ic-suspend-lock-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic-suspend-lock-usage",
      toString: function () {
        return this.url;
      }
    }